import React from 'react';
import MyTasks from './MyTask';

function EmpProgressTask() {
  return <MyTasks defaultStatus="In Progress" />;
}

export default EmpProgressTask;